module.exports = __webpack_public_path__ + "media/bowhit.a92f3fe1.mp3";